import styled, { keyframes, css } from 'styled-components'
import { mediaQueries } from '@tops/global_config'

export const Container = styled.div`
  display:flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
`

export const RadioGroup = styled.div`
  display:flex;
  align-items: flex-start;
  max-width: ${({ width }) => width || '100%'};
  ${({ bold }) => bold ? 'font-weight: 600;' : 'font-weight: 500;'}
`

export const RadioWrapper = styled.div`
  border-radius: 5px;
  text-align: center;
  background: ${({isCurrentValue, theme}) => isCurrentValue ? theme.colors.user.wise.secondary : "white"};
  border: 1px solid ${({theme, isCurrentValue}) => isCurrentValue ? theme.colors.user.wise.secondary : theme.colors.gray};
  color: ${({theme, isCurrentValue}) => isCurrentValue ? theme.colors.user.wise.primary : theme.colors.secondary};
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  &:hover {
    border: 1px solid ${({theme}) => theme.colors.user.wise.secondary};
    color: ${({theme}) => theme.colors.user.wise.primary};
  }
  transition: all 0.2s ease-in;
`;

export const SwitchLabel = styled.label`
  font-family: ${({ theme }) => theme.fonts.lato};
  font-size: 14px;
  font-weight: bold;
  display: block;
  width: 100%;
  height: 100%;
  padding: 5px 10px;
`;

export const Radio = styled.input`
  display: none;
`
export const Label = styled.label`
  font-family: ${({ theme }) => theme.fonts.lato};
  color: ${({ theme }) => theme.colors.darkGray};
  line-height: 40px;
  font-weight: ${({ bold }) => bold ? '600' : '500'};
  ${({ horizontal }) => horizontal && "margin-right: 20px;"}
`
const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`

const fadeInUp = keyframes`
from {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
}

to {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
`

export const ErrorMessage = styled.div`
  min-height: 24px;
  padding-top: 0px;
  color: ${({ theme }) => theme.colors.red};
  font-size: 14px;
  animation:${({ hasError }) => hasError ? fadeInDown : fadeInUp} 0.3s ease;
`